export default "__VITE_ASSET__J$kYFZWO__"